import { bidlClient } from 'src/utils/api'
import { tryQuery } from 'src/utils/queries'

const baseUri = '/api/trade/config/v1/operation'

type EmptyMapping = Record<string, never>

export type TenantCommodity = {
  id: string
  displayName: string
  sourceId: string
}

export type MappingListItem = {
  categorySymbol: string
  categorySymbolName: string
  mappingStatus: MappingStatus
}

export type MappingStatus =
  | { type: 'mapped'; data: { sourceId: string; name: string } }
  | { type: 'perLocationComplete'; data: EmptyMapping }
  | { type: 'perLocationPartiallyComplete'; data: EmptyMapping }
  | { type: 'unmapped'; data: EmptyMapping }

export type MappingLocation = {
  bushelLocationId: string
  locationName: string
  tenantCommodity: TenantCommodity | null
}

export type CommodityMapping =
  | { type: 'global'; data: { tenantCommodity: TenantCommodity } }
  | { type: 'perLocation'; data: EmptyMapping }
  | { type: 'unmapped'; data: EmptyMapping }

export type MappingDetails = {
  categorySymbol: string
  categorySymbolName: string
  mapping: CommodityMapping
  locationMappings: MappingLocation[]
}

export type UpdateCommodityMapping =
  | { type: 'global'; data: { tenantCommodityId: string } }
  | {
      type: 'perLocation'
      data: {
        mappings: Array<{
          bushelLocationId: string
          tenantCommodityId: string
        }>
      }
    }
  | { type: 'unmapped'; data: EmptyMapping }

export type UpdateCommodityMappingRequest = {
  categorySymbol: string
  mapping: UpdateCommodityMapping
}

const tenantHeaders = (tenantId: string) => ({
  'X-Bushel-Tenant': tenantId,
})

export const GetCQGSymbolTenantCommodityMappings = async (tenantId: string) =>
  tryQuery(
    bidlClient.post(
      `${baseUri}/GetCQGSymbolTenantCommodityMappings`,
      {},
      {
        headers: tenantHeaders(tenantId),
      }
    )
  )

export const GetCQGSymbolTenantCommodityMappingDetails = async (
  data: { categorySymbol: string },
  tenantId: string
) =>
  tryQuery(
    bidlClient.post(`${baseUri}/GetCQGSymbolTenantCommodityMappingDetails`, data, {
      headers: tenantHeaders(tenantId),
    })
  )

export const UpdateCQGSymbolTenantCommodityMapping = async (
  data: UpdateCommodityMappingRequest,
  tenantId: string
) =>
  tryQuery(
    bidlClient.post(`${baseUri}/UpdateCQGSymbolTenantCommodityMapping`, JSON.stringify(data), {
      headers: {
        ...tenantHeaders(tenantId),
        'Content-Type': 'application/json',
      },
    })
  )
